import React, { useState, useEffect } from "react";
import { Row, Col, Card, message, Divider, List, Typography, Space } from "antd";
import { ArrowRightOutlined, FormOutlined, EditOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../components/headerPage";
import { HeaderTitle } from "../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import http from "../../services/http";
import { ItemList } from "../../components/itemList";
const { Text, Paragraph } = Typography;

const EleicoesCipa = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  useEffect(() => {
    listarHolerites();
  }, []);

  // LISTAR
  const listarHolerites = async () => {
    setLoading(true);
    const api = await http("get", `v1/eleicoes_cipa_lancamento/listar_eleicoes`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Eleições CIPA" onClickBack={() => navigate("/")} />
            <HeaderTitle title="Eleições" loading={loading} subtitle="Eleições pendentes" icon={<FormOutlined />} />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Text strong style={{ fontSize: 20 }}>
                Minhas Pendências
              </Text>
              <Divider />
              <List
                loading={loading}
                dataSource={dados}
                renderItem={(item) => (
                  <div style={{ paddingBlock: 5 }}>
                    <ItemList
                      onClick={() => navigate(`/eleicoes-cipa/lancamento/${item?.id}`)}
                      leftComponent={
                        <div className="item-collapse-icon" style={{ backgroundColor: "transparent" }}>
                          <EditOutlined style={{ fontSize: 22, color: "#2194f2" }} />
                        </div>
                      }
                      hoverable
                      rightComponent={<ArrowRightOutlined />}>
                      <Space wrap size={10}>
                        <Text strong>{item.eleicao}</Text>
                        <Text type="secondary" style={{ fontSize: 12 }}>
                          {item.ano}
                        </Text>
                      </Space>
                      <Paragraph style={{ margin: 0 }}>{item?.localidade}</Paragraph>
                    </ItemList>
                  </div>
                )}
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};

export default EleicoesCipa;
